<template>
  <img
      v-if="status"
      alt="online"
      src="/web/img/online-50.png"
      style="width: 30px"
  >
  <img
      v-else
      alt="offline"
      src="/web/img/offline-50.png"
      style="width: 30px"
  >
</template>

<script>
export default {
  name: 'SisIconStatus',
  props: {
    status: {
      default: 0
    }
  }
}
</script>
